<template>
  <div class="table hover">
    <!--'게시판: hover'-->
    <div class="row head">
      <div class="cell fix150"><p>번호</p></div>
      <div class="cell"><p>제목</p></div>
      <div class="cell fix240"><p>등록일</p></div>
    </div>
    <div class="empty_wrap" v-if="$Util.isEmpty(items)">
      <div class="empty">
        <span>내역이 존재하지 않습니다.</span>
      </div>
    </div>
    <div
      class="row"
      :class="{ noty: item.isTop === 1 }"
      v-for="(item, index) in items"
      :key="index"
    >
      <div class="cell fix150">
        <p>
          {{ item.isTop === 1 ? '공지' : pageInfo.virtualNum - index }}
        </p>
      </div>
      <div class="cell">
        <p class="left">
          <!--아래 영역 클릭하면 이동하도록 해주세요-->
          <span class="board_ttl" @click="fnView(item)">{{ item.title }}</span>
        </p>
      </div>
      <div class="cell fix240">
        <p class="date">
          {{ $moment(item.regDate).format('YYYY.MM.DD') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news-list-index',
  props: {
    items: {
      type: [Array],
      default: () => []
    },
    pageInfo: {
      type: [Object],
      default: () => {}
    }
  },
  methods: {
    fnView: function(item) {
      this.$emit('view', item)
    }
  }
}
</script>

<style scoped></style>
